import { KeyboardSensorID } from "../../../sensors/KeyboardSensorID";
import { AppCommand } from "../AppCommand";
import { AppCommandBinding } from "../AppCommandBinding";
import { AppCommandBindingEntry } from "../AppCommandBindingEntry";
import { AppCommandContext } from "../AppCommandContext";

export class Redo extends AppCommand
{
  initialize()
  {

    this._name = 
    {
      en: "Redo",
      de: "Wieder machen" 
    }

    this._info = 
    {
      en: "Redoes the last action, which was undone",
      de: "Führt die letzte Aktion wieder aus, die rückgängig gemacht wurde"    
    }

    this._shortCutEntries = 
    [
      AppCommandBindingEntry.forDesktop( 
        AppCommandBinding.primaryWith( KeyboardSensorID.Key_Y )
      )
    ]
  }

  async _execute( context:AppCommandContext<any,any> ):Promise<void>
  {
    await context.webApp.undoManager.redo();    

    return Promise.resolve();
  }
}